import { ActiveRound } from "./Round";

export interface ClientSettings {
  sound_off: boolean;
  music_off: boolean;
  bet: Record<string, string>;
  mines_count: number;
  skipTutorial?: boolean;
}

export interface InitSettings {
  id: string;
  name: string;
  max_multiplier: string;
  type_config: TypeConfig;
  active_round?: ActiveRound | null;
}

export interface TypeConfig {
  board_size: number;
  options: MinesOption[];
}

export interface MinesOption {
  mines_count: number;
  max_multiplier: string;
  pay_table: PayTableEntry[];
}

export interface PayTableEntry {
  reveals: number;
  multiplier: string;
}

export interface BackendSettings {
  currency: CurrencySettings;
  game: GameSettings;
}

export interface CurrencySettings {
  default_bet: string;
  min_bet: string;
  max_bet: string;
  max_win: string;
}

export interface GameSettings {
  rtp: number;
  enabled_features: GameFeatures[];
}

export enum GameFeatures {
  P_F = "F_PROVABILITY_FAIR",
  T = "F_TUTORIAL",
}